import { render, staticRenderFns } from "./I18nMessageTypeManager.vue?vue&type=template&id=2db1fb9c&scoped=true&"
import script from "./I18nMessageTypeManager.vue?vue&type=script&lang=js&"
export * from "./I18nMessageTypeManager.vue?vue&type=script&lang=js&"
import style0 from "./I18nMessageTypeManager.vue?vue&type=style&index=0&id=2db1fb9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1fb9c",
  null
  
)

export default component.exports